<template>
  <div class="security_reset_password">
    <span>{{ $t('meta_title.security.reset_password') }}</span>

    <div class="user_form">
      <form @submit.prevent="post" method="post">
        <div class="form-group">
          <label for="security_password" class="required">{{ $t('object.security.password') }}</label>
          <input type="password" id="security_password" name="password" required class="form-control"
                 v-model="password">
        </div>

        <div class="form-group">
          <label for="security_confirm_password" class="required">{{ $t('object.security.confirm_password') }}</label>
          <input type="password" id="security_confirm_password" name="confirm_password" required class="form-control"
                 v-model="confirm_password">
        </div>
        <input type="submit">
      </form>
    </div>
  </div>
</template>

<script>
  import toast from '@/toastr'

  export default {
    name: 'SecurityResetPassword',
    data() {
      return {
        password: '',
        confirm_password: '',
      }
    },
    methods: {
      post() {
        this.$http.post('user/reset_password/' + this.$route.params.token, {
          password: this.password,
          confirm_password: this.confirm_password
        }, {
          redirectOnSuccess: {name: 'Login'},
          redirectOnFailure: {name: 'Login'}
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Security/reset_password.vue